import { defineStore } from "pinia";
import { apiCommonSearch } from "@/request/api";

// 风险提醒
export default defineStore("useTip", {
    state: () => ({
        info: {},
        isTiped: "N",
    }),
    actions: {
        async getInfo(open) {
            const { code, data } = await apiCommonSearch();
            if (code !== "0") return;
            this.info = data || {};
            if (this.isTiped === "Y" || !data.remind) return; // 本次登录提醒过了或不需要提示，就不自动提醒
            this.isTiped = "Y";
            open();
        },
        setTiped(data) {
            this.isTiped = data || "N";
        },
    },
    persist: {
        enabled: true, // 刷新页面后是否缓存
        strategies: [
            {
                storage: localStorage,
            },
        ],
    },
});
